import React from 'react'
import { StyledBox, StyledFormLabel } from './styles'
import { TextField } from '@mui/material'
import PreparedQuestionCardWrapper from '../PreparedQuestionCardWrapper'
import { type FreeResponseQuestion } from '../../../types'
import { PreparedEmptyField } from '../../../styles'
import { type ISurveySection } from '../../../../../store/slices/SurveyTemplateSlice'

interface FreeResponseCardProps {
  question: FreeResponseQuestion
  questionNumber: number
  index: number
  sectionIndex: number
  totalQuestionInSection: number
  section: ISurveySection
  isEditable?: boolean
  isSurveyTemplate?: boolean
}

const FreeResponseCard: React.FC<FreeResponseCardProps> = ({ question, questionNumber, index, sectionIndex, totalQuestionInSection, section, isEditable, isSurveyTemplate = false }): JSX.Element => {
  return (
    <PreparedQuestionCardWrapper section={section} questionNumber={questionNumber} question={question} index={index} sectionIndex={sectionIndex} totalQuestionInSection={totalQuestionInSection} isEditable={isEditable} isSurveyTemplate={isSurveyTemplate}>
      <>
        <StyledBox >
          {question?.prompt !== undefined && question?.prompt !== ''
            ? <StyledFormLabel >{question?.prompt}</StyledFormLabel>
            : <PreparedEmptyField>Type your question...</PreparedEmptyField>
          }
        </StyledBox>
        <PreparedEmptyField>Type your response</PreparedEmptyField>
      </>
    </PreparedQuestionCardWrapper>
  )
}

export default FreeResponseCard
